module.exports = __webpack_public_path__ + "website/img/dl1.34f90076.jpg";